import { LinkedPeopleInfo, LinkedPeopleInfoInput } from 'sr-types/lib/production/v1/graphql';
import { toContactInputSafe } from './toContactInputSafe';

/**
 * Converts LinkedPeopleInfo (server response type with id, __typename) to LinkedPeopleInfoInput (mutation input type).
 * Explicitly constructs the input shape to avoid sending extra fields like id that GraphQL doesn't accept.
 */
export function toLinkedPeopleInputSafe(linkedPerson: LinkedPeopleInfo): LinkedPeopleInfoInput {
    if (!linkedPerson) {
        return {};
    }

    const input: LinkedPeopleInfoInput = {
        contact: linkedPerson.contact ? toContactInputSafe(linkedPerson.contact) : undefined,
        resourceLabel: linkedPerson.resourceLabel ?? undefined,
        resourceSubType: linkedPerson.resourceSubType ?? undefined,
        resourceType: linkedPerson.resourceType ?? undefined
    };

    return input;
}
